export default __webpack_public_path__ + "static/media/PPI-driveway-016.e73fbc3c.jpg";